//@flow
import * as Immutable from 'immutable';

import { StructuredAddress } from 'common/models/flow/StructuredAddress';
import type { StructuredAddressModelType } from 'common/models/flow/StructuredAddress';

//Validation stuff
import {
    validateCountryCode,
    validatable,
    validate,
    validateAll,
    softValidateAll
} from 'common/utils/ValidationUtil';

import I18nHelper from 'common/helpers/I18nHelper';

const translationsNamespace = ['validations', 'entityManagement'];

const nsTranslate = I18nHelper.translate.bind(null, translationsNamespace);

@validatable
class InternalStructuredAddress extends StructuredAddress {
    static fromJS(json: StructuredAddressModelType): InternalStructuredAddress {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }
    @softValidateAll
    hasValidationErrors(): boolean {
        return false;
    }

    @validateAll
    setAllValidationErrors(): this {
        return this;
    }

    @validate
    setFormattedAddress(formattedAddress: string): this {
        return super.setFormattedAddress(formattedAddress);
    }

    validateFormattedAddress() {
        if (!this.formattedAddress) {
            return nsTranslate('formattedAddressEmpty');
        }
        return null;
    }

    setPincode(pincode: string): this {
        return super.setPincode(pincode);
    }

    @validate
    setCountryCode(countryCode: string): this {
        return super.setCountryCode(countryCode);
    }

    validateCountryCode() {
        if (this.countryCode) {
            return validateCountryCode(this.countryCode);
        }
        return false;
    }

    getFilteredFullAddress({ excludePlaceName } = { excludePlaceName: false }) {
        const fullAddress = this.getFullAddress({
            excludePlaceName
        });
        if (
            fullAddress === this.placeName ||
            fullAddress === this.countryCode
        ) {
            return '';
        }
        return fullAddress;
    }

    getFullAddress({ excludePlaceName } = { excludePlaceName: false }) {
        return [
            excludePlaceName ? '' : this.placeName,
            this.formattedAddress,
            this.locality,
            this.city,
            this.state,
            this.pincode,
            this.countryCode
        ]
            .filter(val => val)
            .join(', ');
    }

    isValid() {
        return (
            [
                this.placeName,
                this.formattedAddress,
                this.locality,
                this.city,
                this.state,
                this.pincode
            ]
                .filter(val => val)
                .join()
                .trim().length > 0
        );
    }
}

export { InternalStructuredAddress as StructuredAddress };
